import {
  User,
  Mail,
  Building2,
  Calendar,
  Clock,
  MessageSquare,
  Activity,
  Globe,
  Users,
  Tag,
  ToggleLeft,
  List,
  Hash,
} from 'lucide-react'
import type { FilterableField } from './types'

export const FIELD_ICONS: Record<string, React.ElementType> = {
  name: User,
  email: Mail,
  company_name: Building2,
  created_at: Calendar,
  last_seen_at: Clock,
  conversations_count: MessageSquare,
  events_count: Activity,
  domain: Globe,
  users_count: Users,
}

export const CUSTOM_TYPE_ICONS: Record<string, React.ElementType> = {
  text: Tag,
  boolean: ToggleLeft,
  list: List,
  numeric: Hash,
  date: Calendar,
}

export function getFieldIcon(field: FilterableField): React.ElementType {
  if (field.custom) {
    return CUSTOM_TYPE_ICONS[field.type] || Tag
  }
  return FIELD_ICONS[field.key] || User
}
